var map = {
	"./ALLERGEN_1.png": 5821,
	"./ALLERGEN_10.png": 9118,
	"./ALLERGEN_11.png": 7177,
	"./ALLERGEN_12.png": 2485,
	"./ALLERGEN_13.png": 6511,
	"./ALLERGEN_14.png": 5849,
	"./ALLERGEN_2.png": 1732,
	"./ALLERGEN_3.png": 9204,
	"./ALLERGEN_4.png": 4329,
	"./ALLERGEN_5.png": 3665,
	"./ALLERGEN_6.png": 1257,
	"./ALLERGEN_7.png": 9720,
	"./ALLERGEN_8.png": 7822,
	"./ALLERGEN_9.png": 4717
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2769;